import { useRef, useState, useEffect} from "react";
import axios from "axios";
import { useAuth } from "./useAuth";
import { SiChatbot } from "react-icons/si";
import { useNavigate } from "react-router-dom";

export const API_URL = "https://aidev.gravitinfosystems.com:4000";

const intentRoutes = {
  greetings: "/",
  services:"/",
  about: "/aboutus",
  jobs_internships: "/career",
  partnership: "/",
  web_dev: "/webdevelopement",
  app_dev: "/appdevelopement",
  AI: "/",
  ML: "/",
  salesforce_consulting: "/salesforce",
  dedicated_team: "/",
  it_consulting: "/itconsulting",
};

export const useChat = () => {
  const navigate = useNavigate()

  const { user } = useAuth();
  const messagesEndRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isChatActive, setIsChatActive] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [messageLoading, setMessageLoading] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [chats, setChats] = useState([]);
  const [isViewingHistory, setIsViewingHistory] = useState(false);
  const [greetingSent, setGreetingSent] = useState(false);
  const [showMenubtn , setShowMenubtn] = useState(false)


  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSendMessage = async (message = inputMessage) => {
    if (!user?.email) {
      console.error("User email is missing");
      setMessages((prev) => [
        ...prev,
        { content: "Please log in to continue.", isBot: true, timestamp: new Date() },
      ]);
      return;
    }

    if (!message.trim) {
      console.error("Message is empty");
      return;
    }

    setMessages((prev) => [
      ...prev,
      { content: message, isBot: false, timestamp: new Date() },
    ]);

    setInputMessage("");
    setMessageLoading(true);

    try {
      const payload = { email: user.email, message };
      const { data } = await axios.post(`${API_URL}/chats`, payload);

      setMessages((prev) => [
        ...prev.filter((msg) => !msg.isLoading),
        {
          content: data.response,
          isBot: true,
          icon: <SiChatbot />,
          timestamp: new Date(),
        },
      ]);

      setSelectedOptions(data.options || []);
    } catch (error) {
      console.error("Error sending message:", error.response?.data || error.message);
      setMessages((prev) => [
        ...prev.filter((msg) => !msg.isLoading),
        { content: "Sorry, something went wrong. Please try again.", isBot: true, icon: "⚠️", timestamp: new Date() },
      ]);
    } finally {
      setTimeout(() => setMessageLoading(false), 3000);
    }
  };

  const handleSelectOption = async (optionKey) => {
    const selectedOption = selectedOptions.find((option) => option.label === optionKey); // select the option

    if (selectedOption) {
      setMessages((prev) => [
        ...prev,
        { content: selectedOption.value, isBot: false, timestamp: new Date() },
      ]);
      setSelectedOptions([]);
      setMessageLoading(true);
      setShowMenubtn(false);

      try {

        const payload = { email: user.email, selected_option: optionKey };
        const { data } = await axios.post(`${API_URL}/res_chats`, payload);

        if (data.response) {
          setMessages((prev) => [
            ...prev,
            {
              content: data.response,
              isBot: true,
              icon: <SiChatbot />,
              timestamp: new Date(),
            }
          ]);
        }

        if(intentRoutes[optionKey]){
          navigate(intentRoutes[optionKey])
          window.scrollTo(0, 0);
        }

        if (data.options?.length > 0) {
          setSelectedOptions(data.options);
        } else if (!data.intent) {
          // **Show "Back to Main Menu" button only when intent is null**
          setTimeout(() => {
            setMessages((prev) => [
              ...prev,
              {
                content: "",
                isBot: true,
                timestamp: new Date(),
                options: [{ label: "Back to Main Menu", action: handleBacktoMainMenu }],
              },
            ]);
          }, 500); // Small delay for smoother display

          setShowMenubtn(true)
        }

      } catch (error) {
        console.error("Error handling selected option:", error.response?.data || error.message);
        setMessages((prev) => [
          ...prev,
          { content: "Sorry, something went wrong. Please try again.", isBot: true, icon: "⚠️", timestamp: new Date() },
        ]);
      } finally{
        setMessageLoading(false)
      }
    } else {
      console.error("Option not found");
    }
  };

  const fetchChatHistory = async () => {
    if (!user?.email) return;

    setMessageLoading(true)
    try {
      const { data } = await axios.get(`${API_URL}/chats/${user.email}`);
      setChats(data.chat_history);
      setIsViewingHistory(true);
      setIsChatActive(false);
    } catch (error) {
      console.error("Error fetching chat history:", error);
    } finally {
      setMessageLoading(false)
    }
  };

  const toggleChat = () => {
    setIsOpen((prev) => !prev);
  }

  const handleChatOpen = async () => {
    // alert("hi menu acitve")
    setIsChatActive(true);
    setIsViewingHistory(false);
    setMessageLoading(true)
    setShowMenubtn(false)
  
    // console.log("hello")
    // if (greetingSent) return;
    try {
      // console.log("Hiiii")
      const payload = { email: user.email, selected_option: "greetings"};
      const { data } = await axios.post(`${API_URL}/res_chats`, payload);
      
      if(data.response){
        setMessages((prev) => [
          ...prev , {
            content: data.response, 
            isBot: true,
            icon: <SiChatbot />,
            timestamp: new Date(),
          }
        ])
      }
      setSelectedOptions(data.options || []);
      setGreetingSent(true);

      if (data.options && data.options.length > 0) {
        setSelectedOptions(data.options || []);
        setShowMenubtn(false); 
      } else {
        setSelectedOptions([]);
        setShowMenubtn(true);
      }
    } catch (error) {
      console.error("Error sending greeting:", error.response?.data || error.message);
      setMessages((prev) => [
        ...prev,
        { content: "Sorry, something went wrong. Please try again.", isBot: true, icon: "⚠️", timestamp: new Date() },
      ]);
    }finally {
      setMessageLoading(false)
    }
  };
  
  const handleBack = () => {
    setIsChatActive(false);
    setIsViewingHistory(false);
  };


  const handleBacktoMainMenu = () => {
    setMessages([]);
    setSelectedOptions([])
    setGreetingSent(false)
    handleChatOpen()
    setShowMenubtn(false)
  }

  useEffect(() => {
    let timeoutId;

    if (!isChatActive && user && !greetingSent) {
      setMessageLoading(true);
      timeoutId = setTimeout(() => {
        handleChatOpen();
      }, 3000);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isChatActive, user]);


  useEffect(() => {
    scrollToBottom();
  }, [messages , isViewingHistory]);

  return {
    showMenubtn,
    setIsOpen,
    isOpen,
    isChatActive,
    isViewingHistory,
    messages,
    chats,
    inputMessage,
    messageLoading,
    messagesEndRef,
    handleSendMessage,
    setInputMessage,
    toggleChat,
    handleChatOpen,
    handleBack,
    setIsViewingHistory,
    selectedOptions,
    fetchChatHistory,
    handleSelectOption,
    handleBacktoMainMenu
  };
};
